<template>
  <v-form v-model="isPaymentMethodFormValid" ref="paymentMethodForm">
    <v-row no-gutters>
      <v-col cols="12" md="12" class="mb-5">
        <StripeCard @card-input-change="onCardChange" />
      </v-col>
      <v-col cols="12" md="12">
        <div class="body-heading-medium mb-5">Billing Details</div>
        <v-text-field label="Billing Email" name="email" type="text" outlined required dense :rules="emailRules" v-model="newPaymentMethod.billing_details.email" />
        <v-text-field label="Address" name="address" type="text" outlined required dense :rules="requiredFieldRule" v-model="newPaymentMethod.billing_details.address.line1" />
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field label="City" name="city" type="text" outlined required dense :rules="requiredFieldRule" v-model="newPaymentMethod.billing_details.address.city" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Postal Code" name="postal" type="text" outlined dense required :rules="postalCodeRules" v-model="newPaymentMethod.billing_details.address.postal_code" />
          </v-col>
        </v-row>
        <v-autocomplete required :rules="requiredFieldRule" outlined dense v-model="newPaymentMethod.billing_details.address.country" :items="countries" label="Country" :menu-props="{ offsetY: true }" />
        <p>Your payment method will be saved for future purchase</p>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn color="secondary" @click="savePaymentMethod" :disabled="!(isPaymentMethodFormValid && isCardValid)">
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import countries from "../../consts/countries";
  import StripeCard, { stripeCardElement } from "./StripeCard";

  export default {
    name: "PaymentMethodForm",

    data() {
      return {
        countries: countries,
        isCardValid: false,
        isPaymentMethodFormValid: false,
        emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
        postalCodeRules: [(v) => !!v || "Postal code is required", (v) => /([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\ ([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])/.test(v) || "Postal code must be valid(all uppercase letters with one space after the first 3 characters)"],
        requiredFieldRule: [(v) => !!v || "Field is required"],
      };
    },

    props: ["paymentMethod"],

    components: { StripeCard },

    computed: {
      newPaymentMethod: {
        get() {
          return this.paymentMethod ? this.$_.extend({}, this.paymentMethod) : { billing_details: { address: {} } };
        },
        set(newValue) {
          return newValue;
        },
      },
    },

    methods: {
      reset() {
        this.isCardValid = false;
        this.isPaymentMethodFormValid = false;

        if (this.$refs.paymentMethodForm) {
          this.$refs.paymentMethodForm.resetValidation();
        }
      },

      onCardChange(event) {
        this.isCardValid = event.complete;
      },

      confirmCardSetupStripeSuccess(result) {
        //Fetch payment methods and store them in Vuex store
        this.$http
          .get("/cards")
          .then((response) => {
            this.$store.commit("addPaymentMethods", response.data.data);
            this.$emit("force-close");

            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: this.$formatter.getErrorMsg(error),
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      },

      confirmCardSetupStripe(clientSecret) {
        let paymentMethod = {
          payment_method: {
            card: stripeCardElement,
            billing_details: this.newPaymentMethod.billing_details,
          },
        };

        this.$stripe.confirmCardSetup(clientSecret, paymentMethod).then((result) => {
          if (result.error) {
            console.error(result.error);
            this.$store.commit("setError", {
              message: result.error.message,
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          } else {
            this.confirmCardSetupStripeSuccess(result);
          }
        });
      },

      savePaymentMethod() {
        this.$store.commit("setLoadingStatus", true);
        if (this.$validator.isEmpty(this.newPaymentMethod.card)) {
          //Create Stripe SetupIntent
          this.$http
            .post("/cards")
            .then((response) => {
              if (response.data.client_secret) {
                //Confirm card setup
                this.confirmCardSetupStripe(response.data.client_secret);
              } else {
                this.$store.commit("setError", {
                  message: this.$formatter.getErrorMsg(),
                  type: "error",
                });
                this.$store.commit("setLoadingStatus", false);
              }
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", {
                message: this.$formatter.getErrorMsg(error),
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        } else {
          this.$store.commit("setLoadingStatus", false);
        }
      },

      cancel() {
        this.reset();
        this.newPaymentMethod = {};
        this.$emit("force-close");
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Payment/PaymentMethodForm.vue